export const getCommercialTypeKey = 'getCommercialType';
export const getCommercialMarkKey = 'getCommercialMark';
export const getCommercialModelKey = 'getCommercialModel';
export const getCommercialBodyTypeKey = 'getCommercialBodyType';
export const getCommercialModificationKey = 'getCommercialModification';
export const getCommercialCharacteristicKey = 'getCommercialCharacteristic';
export const getCommercialEngineVolumeKey = 'getCommercialEngineVolume';
export const getCommercialPowerKey = 'getCommercialPower';
